interface AddressLike {
  streetNumber?: string | null;
  route?: string | null;
  locality?: string | null;
  state?: string | null;
  postalCode?: string | null;
}

/**
 * Mirrors the backend `Address.as_single_line`:
 * line1 = streetNumber + route, line2 = locality + state + postalCode,
 * joined by ", ".
 */
export function formatAddress(
  address: AddressLike | Record<string, unknown> | null | undefined,
): string | null {
  if (!address) return null;
  const a = address as AddressLike;
  const line1 = [a.streetNumber, a.route].filter(Boolean).join(" ");
  const line2 = [a.locality, a.state, a.postalCode].filter(Boolean).join(" ");
  return [line1, line2].filter(Boolean).join(", ") || null;
}
